import React from "react";
// import img from '../marketplaceassets/buildimg.png';
import "./CloudGrowth.css";

export default function CloudGrowth() {
  return (
    <div id="cloud-growth" className="cloudmainclass">
      <div className="left">
        <h2 className="heading">
       Powering Growth with Secure Cloud Consulting </h2>
        <p className="subheading">
      At BastionEx, we deliver secure, scalable cloud consulting services that optimize performance, reduce costs, and enable growth-ready cloud operations.  </p>
        <button>Book your free consultation</button>
      </div>
      {/* <div className="right">
            <img src={img} alt="error" />
        </div> */}
    </div>
  );
}
